const PRECOS_TESTE = {
  solo: 5,
  equipe: 6,
  pro: 7,
};

const precoTesteAtivo = () => {
  const raw = String(process.env.REACT_APP_ASSINATURA_PRECO_TESTE ?? "").trim().toLowerCase();
  return raw === "true" || raw === "1";
};

const precoPlano = (planoId, precoPadrao) => {
  if (!precoTesteAtivo()) return precoPadrao;
  return PRECOS_TESTE[planoId] ?? precoPadrao;
};

export const PERIODOS = [
  { id: "monthly", label: "Mensal", months: 1, multiplier: 1 },
  { id: "quarterly", label: "3 meses", months: 3, multiplier: 3 },
  { id: "semiannual", label: "6 meses", months: 6, multiplier: 6 },
  { id: "yearly", label: "Anual", months: 12, multiplier: 11 },
];

export const PLANOS_PAGOS = [
  {
    id: "solo",
    nome: "Solo",
    precoMensal: precoPlano("solo", 39.9),
    profissionais: "1 profissional",
    destaque: false,
    recursos: ["Agendamentos ilimitados", "1 profissional", "Painel completo", "App para clientes"],
  },
  {
    id: "equipe",
    nome: "Equipe",
    precoMensal: precoPlano("equipe", 59.9),
    profissionais: "Até 5 profissionais",
    destaque: true,
    recursos: ["Agendamentos ilimitados", "Até 5 profissionais", "Painel completo", "App para clientes"],
  },
  {
    id: "pro",
    nome: "Pro",
    precoMensal: precoPlano("pro", 89.9),
    profissionais: "Profissionais ilimitados",
    destaque: false,
    recursos: ["Agendamentos ilimitados", "Profissionais ilimitados", "Painel completo", "App para clientes"],
  },
];

export const PLANO_TRIAL = {
  id: "trial",
  nome: "Trial",
  duracaoDias: 45,
  recursos: [
    "45 dias grátis",
    "1 profissional (mesmo limite do Solo)",
    "Sem cartão no cadastro",
    "Assine um plano pago antes do fim do trial",
  ],
};

export const FORMAS_PAGAMENTO = [
  { id: "pix", label: "PIX", descricao: "Confirmação rápida" },
  { id: "cartao", label: "Cartão de crédito", descricao: "Renovação automática" },
];

export const STATUS_LABELS = {
  pending_plan: "Plano pendente",
  awaiting_payment: "Aguardando pagamento",
  trial: "Trial ativo",
  active: "Plano ativo",
  suspended: "Suspenso",
  carencia: "Renovação pendente",
};

export function obterPeriodo(periodoId) {
  return PERIODOS.find((p) => p.id === periodoId) || PERIODOS[0];
}

export function obterPlanoPago(planoId) {
  return PLANOS_PAGOS.find((p) => p.id === planoId) || null;
}

export function calcularPrecoPeriodo(precoMensal, periodoId) {
  const periodo = obterPeriodo(periodoId);
  return Math.round(precoMensal * periodo.multiplier * 100) / 100;
}

export function calcularEquivalenteMensal(precoMensal, periodoId) {
  const periodo = obterPeriodo(periodoId);
  const total = calcularPrecoPeriodo(precoMensal, periodoId);
  return Math.round((total / periodo.months) * 100) / 100;
}

export function formatarMoeda(valor) {
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(valor);
}

export function labelPlano(planoId) {
  if (planoId === "trial") return PLANO_TRIAL.nome;
  return obterPlanoPago(planoId)?.nome || planoId;
}

export function labelPeriodo(periodoId) {
  return obterPeriodo(periodoId).label;
}
